import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import CardsGroupDashboard from "../../components/Cards/CardsGroupDashboard";
import CardsGroupDashboard2 from "../../components/Cards/CardsGroupDashboard2";
import CardsGroupDashboardAge from "../../components/Cards/CardsGroupDashboardAge";
import CardsGroupDashboardDrug from '../../components/Cards/CardsGroupDashboardDrug';
import PrecisionSectionHeader from "./PrecisionSection/PrecisionSectionHeader";
import DrugHeader from './RightDrug/Drugs/DrugHeader';
import AgeCard from "./BioAge/AgeCard";
import GenomicsCard from "./Genomics/GenomicsCard";
import MicrobiotaCard from "./Microbiota/MicrobiotaCard";
import BioCard from "./BioAge/BioCard";
import HealthSectionHeader from "./HealthSection/HealthSectionHeader";
import HealthSectionHeaderAge from "./HealthSection/HealthSectionHeaderAge";
import CVCard from "./HealthSection/CVCard";
import ImmuneCard from "./HealthSection/ImmuneCard";
import NeuroCard from "./HealthSection/NeuroCard";
import SkinCard from "./HealthSection/SkinCard";
import EyesCard from "./HealthSection/EyesCard";
import CancerCard from "./HealthSection/CancerCard";
import DrugCard from "./RightDrug/DrugCard"



export default function MainSection() {
    
return (
<>
<Grid container sx={{mt:8,}}>

      <Grid item xs={12} sx={{ display: 'flex', justifyContent:'center', alignItems: 'center' }}>

                <CardsGroupDashboardAge 
                     header0 = { <HealthSectionHeaderAge />}
                     age = { <AgeCard /> }  
                     card31 = { <BioCard /> }    
                />
         </Grid>

         <Grid item xs={12} sx={{ display: 'flex', justifyContent:'center', alignItems: 'center' }}>                    
         
         <Stack direction = {{xs: "column", md: "row"}} spacing={4}>
  
                <CardsGroupDashboardDrug
                        header4 = { <DrugHeader />} 
                        card41 = { <DrugCard />}
                        />

                <CardsGroupDashboard2
                    header2 = { <HealthSectionHeader />} 
                            card21 = { <CVCard /> }
                            card22 = { <ImmuneCard />}
                            card23 = { <NeuroCard />}
                            card24 = { <SkinCard />}
                            card25 = { <EyesCard />}
                            card26 = { <CancerCard />}
                    />
                
                <CardsGroupDashboard
                    header1 = { <PrecisionSectionHeader />} 
                            card11 = {<GenomicsCard /> }
                            card12 = {<MicrobiotaCard /> }
                            card13 = { '' }
                            />
          </Stack>
          </Grid>
          
</Grid>
</>)}